import { ReactNode } from "react";
import SectionIndex from "../../common/components/SectionIndex";

const FormSectionContainer: React.FC<FormSectionContainerProps> = ({
  children,
  index,
}) => {
  return (
    <div className="form-section-container">
      <SectionIndex index={index}></SectionIndex>

      <div className="d-flex flex-column w-100">{children}</div>
    </div>
  );
};

export default FormSectionContainer;

export interface FormSectionContainerProps {
  children?: ReactNode;
  index: number;
}
